import * as types from "../../constants";
import { ActionsOf, init } from "../utils";
import * as actions from "../actions-declarations/units";
import { AccessibilityUnit } from "../../models/AccessibilityUnits";

export type UnitsActions = typeof actions;

export type UnitsActionType = {
  units: any;
  unit: any;
  payload?: any;
  unit_levels: any
};

export type UnitType = {
  units: AccessibilityUnit[];
  unit?: object | undefined;
  unit_levels?: any
  accessibilityUnitsCounts: Array<{name: string, value: number}> | null
};

export default function reducer(
  state = init<UnitType>({
    units: [],
    accessibilityUnitsCounts: null
  }),
  actions: ActionsOf<UnitsActions>
): typeof state {
  switch (actions.type) {
    case types.FETCH_UNITS:
      return {
        ...state,
        units: actions.units,
      };
    case types.CLEAR_UNITS:
      return {
        ...state,
        units: [],
      };
    case types.CREATE_UNIT:
      return {
        ...state,
        units: [...state.units, actions.unit],
      };
    case types.DELETE_UNIT:
      let updateUnits = state.units.filter((i) => i.id !== actions.unit.id)
      return {
        ...state,
        units: updateUnits,
      };
    case types.UPDATE_UNIT:
      // let units = state.units.slice(0);
      // units[actions.payload.index] = actions.payload.response.data;
      return {
        ...state,
      };

    case types.FETCH_UNIT_LEVELS:
      return {
        ...state,
        unit_levels: actions.unit_levels,
      };
    case types.CREATE_UNIT_LEVELS:
      return {
        ...state,
        units: [...state.units, actions.unit],
      };
    case types.UPDATE_UNIT_LEVELS:
      // let units = state.units.slice(0);
      // units[actions.payload.index] = actions.payload.response.data;
      return {
        ...state,
        // units,
      };

    case types.FETCH_ACCESSIBILITY_UNITS_COUNTS:
      return {
        ...state,
        accessibilityUnitsCounts: actions.payload
      };
    case types.CLEAR_ACCESSIBILITY_UNITS_COUNTS:
      return {
        ...state,
        accessibilityUnitsCounts: null!
      };

    default:
      return state;
  }
}
